import { render } from "./DashboardContentHeader.vue?vue&type=template&id=5ac34566&ts=true"
import script from "./DashboardContentHeader.vue?vue&type=script&lang=ts"
export * from "./DashboardContentHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__